import Button from 'react-bootstrap/Button';
import { FaUserPlus } from 'react-icons/fa';

const AddContactBtn = ({ addContact }) => {
 return (
  <Button
   className='addBtn btn btn-primary'
   type='button'
   size='lg'
   href={addContact}
   target='_blank'
   rel='noopener noreferrer'>
   <FaUserPlus className='text-warning mr-2' size={25} />{' '}
   <span className='text-blue'> שמור אותי באנשי הקשר</span>
  </Button>
 );
};

export default AddContactBtn;
